import React, { forwardRef, useContext, useEffect } from 'react';
import IframePage from '@modules/iframePage';
import './cutomizedModuleStyle.scss';
import SectionComment from 'src/ddvComment/SectionComment';
// import SectionComment from '@components/CommentCenter/SectionComment';
import AnchorComponent from '@modules/customizedModule/anchorComponent';

import { urlTabMap } from '@components/directUser/data';
import { useSelector } from 'react-redux';
import { getValueFromSearchParam } from '@utils/history';

function CustomizedIframeModule(props, ref) {
  const { moduleValue } = getValueFromSearchParam('moduleValue');
  const { customizedModules = [] } = useSelector(({ projects }) => ({
    customizedModules: projects?.customizedModules,
  }));
  const moduleName = customizedModules.find(
    (i) => i.value === moduleValue,
  )?.module;

  useEffect(() => {
    urlTabMap['/link'] = { moduleName, identifier: moduleValue };
    return () => {
      Reflect.deleteProperty(urlTabMap, '/link');
    };
  }, [moduleValue]);

  const extraButton = (
    <div className="customized-module-comment-icon">
      <SectionComment
        module={moduleName}
        component=""
        placement="bottomRight"
        sendIdentifier={moduleValue}
        // getPopupContainer={() =>
        //   document.getElementsByClassName('integration-tile')[0]
        // }
      />
      <AnchorComponent anchorId={moduleValue} />
    </div>
  );

  return <IframePage {...props} ref={ref} extraButton={extraButton} />;
}

export default forwardRef(CustomizedIframeModule);
